module.exports = __webpack_public_path__ + "static/media/brand32.57c7d692.png";